export default __webpack_public_path__ + "32d2ff874dcddac5fd430552ea771a34.svg";